<template>
  <div v-loading="loading">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="订单设置" name="first">
        <el-card class="box-card" style="height: calc(100vh - 140px) ">
          <div slot="header" class="header clearfix">
            <span>订单设置</span>
            <div style="float: right;display: inline;">
              <el-button
                type="primary"
                size="mini"
                @click="handleAddBaseInfo" style="float: right;margin-left: 10px;">
                添加
              </el-button>
              <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" size="mini" style="float: right;margin-left: 0px;" @click="loadBaseInfoData()">
                搜索</el-button>
              <el-input v-model="filterParams.cityName" placeholder="输入城市名称搜索"  style="float: right;width:300px;" clearable=""/>
            </div>
          </div>
          <div class="body">
            <el-table
              :data="dataBaseList"
              v-loading="isLoading"
              :height="maxHeight"
              style="width: 100%">
              <el-table-column
                prop="cityName"
                label="城市"
                width="180">
              </el-table-column>
              <el-table-column
                label="提前下单时间"
                prop="timeRegion"
                :formatter="formatterTimeRegion"
                width="180">
                <template slot-scope="scope">
                  <span v-if="scope.row.timeRegion=='1'">1小时</span>
                  <span v-if="scope.row.timeRegion=='2'">2小时</span>
                  <span v-if="scope.row.timeRegion=='3'">3小时</span>
                  <span v-if="scope.row.timeRegion=='5'">5小时</span>
                  <span v-if="scope.row.timeRegion=='8'">8时</span>
                  <span v-if="scope.row.timeRegion=='24'">1天</span>
                  <span v-if="scope.row.timeRegion=='48'">2天</span>
                  <span v-if="scope.row.timeRegion=='72'">3天</span>
                  <span v-if="scope.row.timeRegion=='100'">5天</span>
                  <span v-if="scope.row.timeRegion=='-1'">不限</span>
                </template>
              </el-table-column>
              <el-table-column
                label="推送B类时间">
                <template slot-scope="scope">
                  <span v-if="scope.row.pushTimeRegionBl=='15'">15分钟</span>
                  <span v-if="scope.row.pushTimeRegionBl=='30'">30分钟</span>
                  <span v-if="scope.row.pushTimeRegionBl=='45'">45分钟</span>
                  <span v-if="scope.row.pushTimeRegionBl=='60'">1小时</span>
                  <span v-if="scope.row.pushTimeRegionBl=='90'">1个半小时</span>
                  <span v-if="scope.row.pushTimeRegionBl=='120'">2小时</span>
                  <span v-if="scope.row.pushTimeRegionBl=='-1'">不限</span>
                </template>
              </el-table-column>
              <el-table-column
                label="推送C类时间">
                <template slot-scope="scope">
                  <span v-if="scope.row.pushTimeRegionCl=='15'">15分钟</span>
                  <span v-if="scope.row.pushTimeRegionCl=='30'">30分钟</span>
                  <span v-if="scope.row.pushTimeRegionCl=='45'">45分钟</span>
                  <span v-if="scope.row.pushTimeRegionCl=='60'">1小时</span>
                  <span v-if="scope.row.pushTimeRegionCl=='90'">1个半小时</span>
                  <span v-if="scope.row.pushTimeRegionCl=='120'">2小时</span>
                  <span v-if="scope.row.pushTimeRegionCl=='-1'">不限</span>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="200">
                <template slot-scope="scope">
                  <el-button @click="editBaseInfo(scope.row)" type="text" size="small">编辑</el-button>
                  <el-button @click="delBaseInfo(scope.row)" type="text" size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              :current-page="page.currentPage"
              :page-sizes="page.pageSizes"
              :total="page.total"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"/>
          </div>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="派单设置" name="second">
        <el-card class="box-card" style="height: calc(100vh - 140px) ">
          <div slot="header" class="header clearfix">
            <span>手动派单城市（默认均为抢单）</span>
            <div style="float: right;display: inline;">
              <el-button
                type="primary"
                size="mini"
                @click="handleAdd" style="float: right;margin-left: 10px;">
                添加
              </el-button>
              <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" size="mini" style="float: right;margin-left: 0px;" @click="search()">
                搜索</el-button>
              <el-input v-model="filterParams.cityName" placeholder="输入城市名称搜索"  style="float: right;width:300px;" clearable=""/>
            </div>
          </div>
          <div class="body">
            <div v-for="item in dataList" :key="item.id" class="text item">
              <div><span>{{item.cityName}}</span><span style="float: right;margin-right: 20px;color: #1ea0ff;cursor: pointer" @click="delCity(item.id)">移除</span></div>
            </div>
            <div v-if="dataList.length==0" style="text-align: center;color: #999;line-height: 200px;"><span>暂无数据</span></div>
          </div>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="费用标准" name="three">
        <el-card class="box-card" style="height: calc(100vh - 140px) ">
          <div slot="header" class="header clearfix">
            <span>费用标准</span>
            <div style="float: right;display: inline;">
              <el-button
                type="primary"
                size="mini"
                @click="handleBatchCostInfo" style="float: right;margin-left: 10px;">
                一键调价
              </el-button>
              <el-button
                type="primary"
                size="mini"
                @click="handleAddCostInfo" style="float: right;margin-left: 10px;">
                添加
              </el-button>
              <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" size="mini" style="float: right;margin-left: 0px;" @click="initCostInfoData()">
                搜索</el-button>
              <el-input v-model="filterParams.cityName" placeholder="输入城市名称搜索"  style="float: right;width:300px;" clearable=""/>
              <select-text v-model="filterParams.projectId" :multiple="false" code-set-id="" :options="projectOptions"  placeholder="所属项目" style="height:28px;width: 220px;"/>
            </div>
          </div>
          <div class="body">
            <el-table
              :data="dataCostList"
              v-loading="isLoading"
              :height="maxHeight"
              style="width: 100%">
              <el-table-column
                prop="cityName"
                label="城市"
                width="180">
              </el-table-column>
              <el-table-column
                  label="是否公海">
                <template slot-scope="scope">
                  <span>{{ scope.row.isHighSeas=='10060001'?'是':'否' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="projectName"
                  label="所属项目"
                  width="180">
              </el-table-column>
              <el-table-column
                prop="basicFare"
                label="基础车费（元）"
                width="180">
              </el-table-column>
              <el-table-column
                prop="standardTime"
                label="标准时长（分钟）"
                width="180">
              </el-table-column>
              <el-table-column
                prop="timeoutStandard"
                label="超时标准（元/小时）"
                width="180">
              </el-table-column>
              <el-table-column
                prop="realOilPrices"
                label="现实油价（元/L）"
                width="180">
              </el-table-column>
              <el-table-column
                prop="standardTimeXia"
                label="油费标准-夏季（6.1~9.30）"
                width="200">
              </el-table-column>
              <el-table-column
                prop="standardTimeNoxia"
                label="油费标准-非夏季"
                width="180">
              </el-table-column>
              <el-table-column
                label="税率">
                <template slot-scope="scope">
                  <span>{{ scope.row.taxRate }}%</span>
                </template>
              </el-table-column>
              <el-table-column
                label="服务费率">
                <template slot-scope="scope">
                    <span>{{ scope.row.serviceRate }}%</span>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="200">
                <template slot-scope="scope">
                  <el-button @click="editCostInfo(scope.row)" type="text" size="small">编辑</el-button>
                  <el-button @click="delCostInfo(scope.row)" type="text" size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              :current-page="costPage.currentPage"
              :page-sizes="costPage.pageSizes"
              :total="costPage.total"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleCostSizeChange"
              @current-change="handleCostCurrentChange"/>
          </div>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="非公海订单设置" name="four">
        <el-card class="box-card" style="height: calc(100vh - 140px) ">
          <div slot="header" class="header clearfix">
            <span>项目非公海订单城市设置（默认均为公海订单）</span>
            <div style="float: right;display: inline;">
              <el-button
                  type="primary"
                  size="mini"
                  @click="handleHighSeasAdd" style="float: right;margin-left: 10px;">
                添加
              </el-button>
              <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" size="mini" style="float: right;margin-left: 0px;" @click="initHighSeasData()">
                搜索</el-button>
              <select-text v-model="filterParams.projectId" :multiple="false" code-set-id="" :options="projectOptions"  placeholder="所属项目" style="height:28px;width: 220px;"/>
            </div>
          </div>
          <div class="body">
            <div v-for="item in highSeasList" :key="item.id" class="text item">
              <div><span>{{item.projectName}}—>{{item.cityName}}</span><span style="float: right;margin-right: 20px;color: #1ea0ff;cursor: pointer" @click="delHighSeas(item.id)">移除</span></div>
            </div>
            <div v-if="dataList.length==0" style="text-align: center;color: #999;line-height: 200px;"><span>暂无数据</span></div>
          </div>
        </el-card>
      </el-tab-pane>
    </el-tabs>
    <add v-if="showAddVisible" ref="add" @refresh="initData"/>
    <add-base-info v-if="showAddBaseInfoVisible" ref="addBaseInfo" @refresh="initBaseInfoData"/>
    <add-cost-info v-if="showAddCostInfoVisible" ref="addCostInfo" @refresh="initCostInfoData"/>
    <add-batch-cost-info v-if="showBatchCostInfoVisible" ref="addBatchCostInfo" @refresh="initCostInfoData"/>
    <add-high-seas-info v-if="showHighSeasVisible" ref="addHighSeasInfo" @refresh="initHighSeasData"/>
  </div>
</template>
<script>
  import add from './add'
  import addBaseInfo from './add-base-info'
  import addCostInfo from './add-cost-info'
  import addBatchCostInfo from './add-batch-cost-info'
  import addHighSeasInfo from './add-high-seas-info'
  import SelectText from '@/components/SelectText/index.vue'
  import { getDispatchCityList,delDispatchCityById,delBaseInfoSet,getBaseInfoList,delCostInfoSet,getCostInfoList,delHighSeasInfoById,getHighSeasList } from  "@/api/order/orderinfo"
  import {loadProjectList} from "@/api/project";
  export default {
    components: { add,addBaseInfo,addCostInfo,addBatchCostInfo,addHighSeasInfo,SelectText },
    data() {
      return {
        loading:false,
        isLoading:false,
        activeName: 'first',
        showAddVisible: false,
        showAddBaseInfoVisible: false,
        showAddCostInfoVisible: false,
        showBatchCostInfoVisible:false,
        showHighSeasVisible:false,
        selection: [], // 选中的数据
        maxHeight: null,
        clientHeight: null,
        dataList: [],
        highSeasList:[],
        dataBaseList:[],
        dataCostList:[],
        projectOptions:[],
        filterParams: {
          cityName: '',
          projectId:''
        },
        page: {
          pageSizes: [10,20,30,50],
          total: 0,
          currentPage: 1,
          currentPages: 0,
          pageSize: 10
        },
        costPage: {
            pageSizes: [10,20,30,50],
            total: 0,
            currentPage: 1,
            currentPages: 0,
            pageSize: 10
        },
      }
    },
    computed: {

    },
    watch: {
        // 如果 `clientHeight` 发生改变，这个函数就会运行
        clientHeight: function() {
            this.changeFixed(this.clientHeight)
        }
    },
    mounted() {
      this.initData();
      this.initBaseInfoData();
      this.initCostInfoData();
    },
    methods: {
      initData() {
        this.loadData();
        // 获取浏览器可视区域高度
        this.$set(this, 'clientHeight', `${document.documentElement.clientHeight}`)
        window.onresize = function temp() {
            this.$set(this, 'clientHeight', `${document.documentElement.clientHeight}`)
        }
      },
      initBaseInfoData() {
        this.loadBaseInfoData()
      },
      initCostInfoData() {
        this.loadCostInfoData()
      },
      search() {
        this.loadData()
      },
      handleClick(tab, event) {
        this.isLoading = false;
        this.$set(this.filterParams,'cityName','');
        if(tab.name=='four'){
          loadProjectList().then(res => {
            this.projectOptions = res.data.data
            if(res.data.data){
              this.filterParams.projectId = res.data.data[0].codeItemId
              this.initHighSeasData();
            }
          })
        }
        if(tab.name=='three'){
          loadProjectList().then(res => {
            this.projectOptions = res.data.data
          })
        }
      },
      // 表格最大高自适应
      changeFixed(clientHeight) {
          // 导航栏高65+边距上下30*2+ el-table 链接高40 + 分页高32 = 183
          this.$set(this, 'maxHeight', (clientHeight - 65 - (15*2) - 34 - 15 - (18*2) - 30 - 32 - (20*2) ));
      },
      loadData() {
        getDispatchCityList(this.filterParams).then(res => {
          this.dataList = res.data.data
        })
      },
      initHighSeasData() {
        getHighSeasList(this.filterParams).then(res => {
          this.highSeasList = res.data.data
        })
      },
      // 页码变化时
      handleSizeChange(val) {
        // 切换成每页20条的数据
        this.page.pageSize = val
        this.loadBaseInfoData()
      },
      // 当前页变化时
      handleCurrentChange(val) {
        // 获取table数据
        this.page.currentPage = val
        this.loadBaseInfoData()
      },
      loadBaseInfoData() {
        this.isLoading = true;
        let params = this.filterParams;
        params.page= this.page.currentPage;
        params.limit = this.page.pageSize;
        getBaseInfoList(params).then(res => {
            this.page.total = res.data.total;
            this.dataBaseList = res.data.records;
            this.isLoading = false;
        })
      },
      // 页码变化时
      handleCostSizeChange(val) {
        // 切换成每页20条的数据
        this.costPage.pageSize = val
        this.loadCostInfoData()
      },
      // 当前页变化时
      handleCostCurrentChange(val) {
        // 获取table数据
        this.costPage.currentPage = val
        this.loadCostInfoData()
      },
      loadCostInfoData() {
        this.isLoading = true;
        let params = this.filterParams;
        params.page= this.costPage.currentPage;
        params.limit = this.costPage.pageSize;
        getCostInfoList(this.filterParams).then(res => {
            this.costPage.total = res.data.total;
            this.dataCostList = res.data.records;
            this.isLoading = false;
        })
      },
      handleAdd() {
        this.showAddVisible = true
        this.$nextTick(() => {
          this.$refs.add.init()
        })
      },
      handleAddBaseInfo() {
        this.showAddBaseInfoVisible = true
        this.$nextTick(() => {
          this.$refs.addBaseInfo.init()
        })
      },
      handleAddCostInfo() {
        this.showAddCostInfoVisible = true
        this.$nextTick(() => {
          this.$refs.addCostInfo.init()
        })
      },
      handleBatchCostInfo() {
          this.showBatchCostInfoVisible = true
          this.$nextTick(() => {
              this.$refs.addBatchCostInfo.init()
          })
      },
      handleHighSeasAdd(){
        this.showHighSeasVisible = true
        this.$nextTick(() => {
          this.$refs.addHighSeasInfo.init()
        })
      },
      delBaseInfo(row){
        this.$confirm('确定删除该记录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delBaseInfoSet(row.id).then(res => {
            if(res.data.code==0){
              this.$message.success("删除成功")
              this.loadBaseInfoData();
            }
          })
        })
      },
      delCostInfo(row){
        this.$confirm('确定删除该记录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delCostInfoSet(row.id).then(res => {
            if(res.data.code==0){
              this.$message.success("删除成功")
              this.loadCostInfoData();
            }
          })
        })
      },
      editBaseInfo(row){
        this.showAddBaseInfoVisible = true
        this.$nextTick(() => {
          this.$refs.addBaseInfo.init(row.id)
        })
      },
      editCostInfo(row){
        this.showAddCostInfoVisible = true
        this.$nextTick(() => {
          this.$refs.addCostInfo.init(row.id)
        })
      },
      delCity(id){
        this.$confirm('确定移除变为自动抢单吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delDispatchCityById({id:id}).then(res => {
            if(res.data.code==0){
              this.$message.success("移除成功")
              this.initData()
            }
          })
        })
      },
      delHighSeas(id){
        this.$confirm('确定移除变为公海订单吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delHighSeasInfoById({id:id}).then(res => {
            if(res.data.code==0){
              this.$message.success("移除成功")
              this.initHighSeasData();
            }
          })
        })
      }
    }
  }
</script>
<style scoped>
  .text {
    font-size: 14px;
  }
  .item {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #EBEEF5;
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }
  .box-card {
    width: 100%;
  }
  .box-card .header{
    height:30px;
    line-height: 30px;
  }
  .box-card .body {
    height: calc(100vh - 220px);
    overflow-y: auto;
  }
</style>
